import Sidebar from '../'

const mainSidebar = (props) => <Sidebar id="main-sidebar" {...props} />

export default mainSidebar